module.exports = __WEBPACK_EXTERNAL_MODULE_PO2U__;


//////////////////
// WEBPACK FOOTER
// external "popper.js"
// module id = PO2U
// module chunks = 0